import React from 'react'

export default function LoaderQuestion() {
  return (
    <div className="flex animate-pulse flex-col gap-6">
      <div
        className="flex flex-col border-2 border-muted-300"
        data-aos={`fade-up`}
        data-aos-delay={100}
      >
        <div className="h-12 border-b-2 border-muted-300 bg-muted-100 px-4 py-3"></div>
        <div className="flex flex-col gap-1 p-4 pt-2">
          <div className="flex items-center gap-4">
            <label className="flex h-4 w-4 border-2 border-muted-300 bg-muted-100 text-muted-100 peer-checked:border-primary-600 peer-checked:bg-primary-600 peer-checked:text-white"></label>
            <label className="h-2 w-64 bg-muted-300"></label>
          </div>
          <div className="flex items-center gap-4">
            <label className="flex h-4 w-4 border-2 border-muted-300 bg-muted-100 text-muted-100 peer-checked:border-primary-600 peer-checked:bg-primary-600 peer-checked:text-white"></label>
            <label className="h-2 w-64 bg-muted-300"></label>
          </div>
          <div className="flex items-center gap-4">
            <label className="flex h-4 w-4 border-2 border-muted-300 bg-muted-100 text-muted-100 peer-checked:border-primary-600 peer-checked:bg-primary-600 peer-checked:text-white"></label>
            <label className="h-2 w-64 bg-muted-300"></label>
          </div>
          <div className="flex items-center gap-4">
            <label className="flex h-4 w-4 border-2 border-muted-300 bg-muted-100 text-muted-100 peer-checked:border-primary-600 peer-checked:bg-primary-600 peer-checked:text-white"></label>
            <label className="h-2 w-64 bg-muted-300"></label>
          </div>
          <div className="flex items-center gap-4">
            <label className="flex h-4 w-4 border-2 border-muted-300 bg-muted-100 text-muted-100 peer-checked:border-primary-600 peer-checked:bg-primary-600 peer-checked:text-white"></label>
            <label className="h-2 w-64 bg-muted-300"></label>
          </div>
          <div className="flex items-center gap-4">
            <label className="flex h-4 w-4 border-2 border-muted-300 bg-muted-100 text-muted-100 peer-checked:border-primary-600 peer-checked:bg-primary-600 peer-checked:text-white"></label>
            <label className="h-2 w-64 bg-muted-300"></label>
          </div>
        </div>
      </div>
      <div
        className="flex flex-col border-2 border-muted-300"
        data-aos={`fade-up`}
        data-aos-delay={100}
      >
        <div className="h-12 border-b-2 border-muted-300 bg-muted-100 px-4 py-3"></div>
        <div className="flex flex-col gap-1 p-4 pt-2">
          <div className="flex items-center gap-4">
            <label className="flex h-4 w-4 border-2 border-muted-300 bg-muted-100 text-muted-100 peer-checked:border-primary-600 peer-checked:bg-primary-600 peer-checked:text-white"></label>
            <label className="h-2 w-64 bg-muted-300"></label>
          </div>
          <div className="flex items-center gap-4">
            <label className="flex h-4 w-4 border-2 border-muted-300 bg-muted-100 text-muted-100 peer-checked:border-primary-600 peer-checked:bg-primary-600 peer-checked:text-white"></label>
            <label className="h-2 w-64 bg-muted-300"></label>
          </div>
        </div>
      </div>
      <div
        className="flex flex-col border-2 border-muted-300"
        data-aos={`fade-up`}
        data-aos-delay={100}
      >
        <div className="h-12 border-b-2 border-muted-300 bg-muted-100 px-4 py-3"></div>
        <div className="flex flex-col gap-1 p-4 pt-2">
          <div className="flex items-center gap-4">
            <label className="flex h-4 w-4 border-2 border-muted-300 bg-muted-100 text-muted-100 peer-checked:border-primary-600 peer-checked:bg-primary-600 peer-checked:text-white"></label>
            <label className="h-2 w-64 bg-muted-300"></label>
          </div>
          <div className="flex items-center gap-4">
            <label className="flex h-4 w-4 border-2 border-muted-300 bg-muted-100 text-muted-100 peer-checked:border-primary-600 peer-checked:bg-primary-600 peer-checked:text-white"></label>
            <label className="h-2 w-64 bg-muted-300"></label>
          </div>
          <div className="flex items-center gap-4">
            <label className="flex h-4 w-4 border-2 border-muted-300 bg-muted-100 text-muted-100 peer-checked:border-primary-600 peer-checked:bg-primary-600 peer-checked:text-white"></label>
            <label className="h-2 w-64 bg-muted-300"></label>
          </div>
          <div className="flex items-center gap-4">
            <label className="flex h-4 w-4 border-2 border-muted-300 bg-muted-100 text-muted-100 peer-checked:border-primary-600 peer-checked:bg-primary-600 peer-checked:text-white"></label>
            <label className="h-2 w-64 bg-muted-300"></label>
          </div>
          <div className="flex items-center gap-4">
            <label className="flex h-4 w-4 border-2 border-muted-300 bg-muted-100 text-muted-100 peer-checked:border-primary-600 peer-checked:bg-primary-600 peer-checked:text-white"></label>
            <label className="h-2 w-64 bg-muted-300"></label>
          </div>
        </div>
      </div>
      <div
        className="flex flex-col border-2 border-muted-300"
        data-aos={`fade-up`}
        data-aos-delay={100}
      >
        <div className="h-12 border-b-2 border-muted-300 bg-muted-100 px-4 py-3"></div>
        <div className="flex flex-col gap-1 p-4 pt-2">
          <div className="flex items-center gap-4">
            <label className="flex h-4 w-4 border-2 border-muted-300 bg-muted-100 text-muted-100 peer-checked:border-primary-600 peer-checked:bg-primary-600 peer-checked:text-white"></label>
            <label className="h-2 w-64 bg-muted-300"></label>
          </div>
          <div className="flex items-center gap-4">
            <label className="flex h-4 w-4 border-2 border-muted-300 bg-muted-100 text-muted-100 peer-checked:border-primary-600 peer-checked:bg-primary-600 peer-checked:text-white"></label>
            <label className="h-2 w-64 bg-muted-300"></label>
          </div>
        </div>
      </div>
      <div
        className="flex flex-col border-2 border-muted-300"
        data-aos={`fade-up`}
        data-aos-delay={100}
      >
        <div className="h-12 border-b-2 border-muted-300 bg-muted-100 px-4 py-3"></div>
        <div className="flex flex-col gap-1 p-4 pt-2">
          <div className="flex items-center gap-4">
            <label className="flex h-4 w-4 border-2 border-muted-300 bg-muted-100 text-muted-100 peer-checked:border-primary-600 peer-checked:bg-primary-600 peer-checked:text-white"></label>
            <label className="h-2 w-64 bg-muted-300"></label>
          </div>
          <div className="flex items-center gap-4">
            <label className="flex h-4 w-4 border-2 border-muted-300 bg-muted-100 text-muted-100 peer-checked:border-primary-600 peer-checked:bg-primary-600 peer-checked:text-white"></label>
            <label className="h-2 w-64 bg-muted-300"></label>
          </div>
          <div className="flex items-center gap-4">
            <label className="flex h-4 w-4 border-2 border-muted-300 bg-muted-100 text-muted-100 peer-checked:border-primary-600 peer-checked:bg-primary-600 peer-checked:text-white"></label>
            <label className="h-2 w-64 bg-muted-300"></label>
          </div>
          <div className="flex items-center gap-4">
            <label className="flex h-4 w-4 border-2 border-muted-300 bg-muted-100 text-muted-100 peer-checked:border-primary-600 peer-checked:bg-primary-600 peer-checked:text-white"></label>
            <label className="h-2 w-64 bg-muted-300"></label>
          </div>
          <div className="flex items-center gap-4">
            <label className="flex h-4 w-4 border-2 border-muted-300 bg-muted-100 text-muted-100 peer-checked:border-primary-600 peer-checked:bg-primary-600 peer-checked:text-white"></label>
            <label className="h-2 w-64 bg-muted-300"></label>
          </div>
        </div>
      </div>
      <div
        className="flex flex-col border-2 border-muted-300"
        data-aos={`fade-up`}
        data-aos-delay={100}
      >
        <div className="h-12 border-b-2 border-muted-300 bg-muted-100 px-4 py-3"></div>
        <div className="flex flex-col gap-1 p-4 pt-2">
          <div className="flex items-center gap-4">
            <label className="flex h-4 w-4 border-2 border-muted-300 bg-muted-100 text-muted-100 peer-checked:border-primary-600 peer-checked:bg-primary-600 peer-checked:text-white"></label>
            <label className="h-2 w-64 bg-muted-300"></label>
          </div>
          <div className="flex items-center gap-4">
            <label className="flex h-4 w-4 border-2 border-muted-300 bg-muted-100 text-muted-100 peer-checked:border-primary-600 peer-checked:bg-primary-600 peer-checked:text-white"></label>
            <label className="h-2 w-64 bg-muted-300"></label>
          </div>
        </div>
      </div>
      <div
        className="flex flex-col border-2 border-muted-300"
        data-aos={`fade-up`}
        data-aos-delay={100}
      >
        <div className="h-12 border-b-2 border-muted-300 bg-muted-100 px-4 py-3"></div>
        <div className="flex flex-col gap-1 p-4 pt-2">
          <div className="flex items-center gap-4">
            <label className="flex h-4 w-4 border-2 border-muted-300 bg-muted-100 text-muted-100 peer-checked:border-primary-600 peer-checked:bg-primary-600 peer-checked:text-white"></label>
            <label className="h-2 w-64 bg-muted-300"></label>
          </div>
          <div className="flex items-center gap-4">
            <label className="flex h-4 w-4 border-2 border-muted-300 bg-muted-100 text-muted-100 peer-checked:border-primary-600 peer-checked:bg-primary-600 peer-checked:text-white"></label>
            <label className="h-2 w-64 bg-muted-300"></label>
          </div>
          <div className="flex items-center gap-4">
            <label className="flex h-4 w-4 border-2 border-muted-300 bg-muted-100 text-muted-100 peer-checked:border-primary-600 peer-checked:bg-primary-600 peer-checked:text-white"></label>
            <label className="h-2 w-64 bg-muted-300"></label>
          </div>
          <div className="flex items-center gap-4">
            <label className="flex h-4 w-4 border-2 border-muted-300 bg-muted-100 text-muted-100 peer-checked:border-primary-600 peer-checked:bg-primary-600 peer-checked:text-white"></label>
            <label className="h-2 w-64 bg-muted-300"></label>
          </div>
          <div className="flex items-center gap-4">
            <label className="flex h-4 w-4 border-2 border-muted-300 bg-muted-100 text-muted-100 peer-checked:border-primary-600 peer-checked:bg-primary-600 peer-checked:text-white"></label>
            <label className="h-2 w-64 bg-muted-300"></label>
          </div>
        </div>
      </div>
    </div>
  )
}
